import React from "react";
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Row,
  Col,
  Form,
  Input,
  Select
} from '@lockerpm/design';

import global from "../../config/global";

const BillingAddress = (props) => {
  const {
    className
  } = props
  const { t } = useTranslation();

  const countries = useSelector((state) => state.resource.countries);

  return (
    <div className={`billing-address ${className}`}>
      <p className="text-[16px] font-semibold mb-6">
        {t('billing.billing_address')}
      </p>
      <Row gutter={[24, 0]}>
        <Col span={24}>
          <Form.Item
            name="address"
            label={<p className="font-semibold">
              {t('common.address')}
            </p>}
            rules={[
              global.rules.REQUIRED(t('common.address')),
            ]}
          >
            <Input
              placeholder={t('placeholder.address')}
            />
          </Form.Item>
        </Col>
        <Col xl={12} lg={12} span={24}>
          <Form.Item
            name="address_city"
            label={<p className="font-semibold">
              {t('common.city')}
            </p>}
            rules={[
              global.rules.REQUIRED(t('common.city')),
            ]}
          >
            <Input
              placeholder={t('placeholder.enter')}
            />
          </Form.Item>
        </Col>
        <Col xl={12} lg={12} span={24}>
          <Form.Item
            name="address_state"
            label={<p className="font-semibold">
              {t('common.state')}
            </p>}
            rules={[]}
          >
            <Input
              placeholder={t('placeholder.enter')}
            />
          </Form.Item>
        </Col>
        <Col xl={12} lg={12} span={24}>
          <Form.Item
            name="address_country"
            label={<p className="font-semibold">
              {t('common.country')}
            </p>}
            rules={[
              global.rules.REQUIRED(t('common.country')),
            ]}
          >
            <Select
              placeholder={t('placeholder.select')}
              showSearch
              options={countries.map((country) => ({
                key: country.country_code,
                value: country.country_code,
                label: <span>
                  <span
                    className={`flag flag-${country.country_code.toLowerCase()}`}
                  />
                  {country.country_name}
                </span>
              }))}
            />
          </Form.Item>
        </Col>
        <Col xl={12} lg={12} span={24}>
          <Form.Item
            name="address_zip"
            label={<p className="font-semibold">
              {t('common.zip')}
            </p>}
            rules={[]}
          >
            <Input
              placeholder={t('placeholder.enter')}
            />
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
}

export default BillingAddress;